import React from 'react';
import Link from 'react-router-dom/Link';
import { isMobilePage } from '../../common/cores';

const RightBar = (props) => {

    const onLogin = () => {
        props.onShowLogin();
        props.setShowMenu();
    }

    const onRegister = () => {
        props.onShowRegister();
        props.setShowMenu();
    }
    return (
        <div data-v-623d66c4="" className={`right-drawer scrollable-auto column  ${isMobilePage() ? "MobileRight" :""} ${props.showMenu ? "show" : ""}`}>
            <div data-v-2fe6782b="" data-v-623d66c4="" className="right-out column">
                <div data-v-2fe6782b="" className="column"  style = {{ flexGrow: 1, flexShrink: 0 }}>
                    { isMobilePage() && <div data-v-2fe6782b="" className="login-wrap column right-out" style={{flexShrink: "0", height: "auto"}}>
                        <div data-v-90635fc8="" data-v-2fe6782b="" className="row" style={{flexDirection: "row"}}>
                            <div className="row" style={{width: "100%", flexDirection: "row"}}>
                                <button data-v-2fe6782b="" className="login-btn button" style={{width: "100%", height: "60px"}} onClick={onLogin}>
                                    <span data-v-2fe6782b="" className="text">
                                        <i data-v-e56d064c="" data-v-2fe6782b="" className="margin-right-5 fa-regular fa-power-off"></i>
                                        로그인
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>}
                    { isMobilePage() && <div data-v-2fe6782b="" className="row" style={{height: "40px", flexDirection: "row", alignItems: "center", flexShrink: "0", width: "100%"}}>
                        <span data-v-2fe6782b="" className="margin-right-5 text">아직 회원이 아니신가요?</span>
                        <div data-v-1faaa10e="" data-v-2fe6782b="" className="row" style={{flexDirection: "row"}}>
                            <div className="row" style={{width: "100%", flexDirection: "row"}}>
                                <button data-v-2fe6782b="" className="signUp-btn button text" style={{background: "transparent"}} onClick={onRegister}>
                                    <span data-v-2fe6782b="" className="text color-gold">회원가입</span>
                                </button>
                            </div>
                        </div>
                            <div data-v-2fe6782b="" className="spacer"></div>
                            {/* <button data-v-2fe6782b="" className="button text" style={{background: "transparent"}} onClick={props.setShowMenu}>
                                <span data-v-2fe6782b="" className="text" style={{color: "rgb(255, 117, 117)", fontWeight: "bold"}}>
                                    <img src="../images/header/hidden.png" alt="" style={{height:"20px", marginLeft: "10px"}}/>
                                </span>
                            </button> */}
                    </div>}
                    <div data-v-2fe6782b="" className="row" style= {{ flexDirection: "row", flexShrink: 0 }}>
                        <a data-v-2fe6782b=""
                            href="/" target="_blank"><img data-v-2fe6782b=""
                                src="../images/Deposity/one.png" alt=""/>
                            </a>
                    </div>
                    {/* <div data-v-734bc4a5="" data-v-2fe6782b="" className="promopage tabs tabs-lg" style= {{ flexGrow: 1 }}>
                        <div data-v-734bc4a5="" className="tabs-header">
                            <div data-v-734bc4a5="" className="tabs-header-item tabs-header-item-active tabs-header-item-fill"
                                style = {{ flexBasis: "0px"}} >
                                이벤트
                            </div>
                        </div>
                        <div data-v-734bc4a5="" className="tabs-content">
                            <div data-v-73382a62="" data-v-2fe6782b="" className="active" data-v-734bc4a5="" style={{}}>
                                <div data-v-b5a26816="" data-v-2fe6782b="" className="promo-list column" data-v-73382a62="">
                                    <div data-v-b5a26816="" className="promo column" >
                                        <a data-v-b5a26816="" to="/events" className="button text" style= {{ background: "transparent" }}>
                                            <img data-v-b5a26816="" src="../images/Deposity/two.png" alt="다폴더 이벤트" />
                                        </a>
                                    </div>
                                    <div data-v-b5a26816="" className="promo column">
                                        <a data-v-b5a26816="" to="/events" className="button text" style={{ background: "transparent" }}>
                                            <img data-v-b5a26816="" src="../images/Deposity/tree.png" alt="낙첨금 이벤트" />
                                        </a>
                                    </div>
                                    <div data-v-b5a26816="" className="promo column">
                                        <a data-v-b5a26816="" to="/events" className="button text" style={{ background: "transparent" }}>
                                            <img data-v-b5a26816="" src="../images/Deposity/four.png" alt="올낙첨 이벤트" />
                                        </a>
                                    </div>
                                    <div data-v-b5a26816="" className="promo column">
                                        <a data-v-b5a26816="" to="/events" className="button text" style={{ background: "transparent" }}>
                                            <img data-v-b5a26816="" src="../images/Deposity/five.png" alt="첫가입 첫충전 이벤트" />
                                        </a>
                                    </div>
                                    <div data-v-b5a26816="" className="promo column">
                                        <a data-v-b5a26816="" to="/events" className="button text" style={{ background: "transparent" }}>
                                            <img data-v-b5a26816="" src="../images/Deposity/six.png" alt="매일 옵션 이벤트 25%" />
                                        </a>
                                    </div> 
                                    <Link data-v-b5a26816="" to="/events" className="more-btn button">
                                        <span data-v-b5a26816="" className="text" style= {{ height: "auto"}}>더보기</span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
        </div>
        );
};

export default RightBar;


// WEBPACK FOOTER //
// ./src/components/account/RightBar.js